/* eslint-disable no-new */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// babel-polyfill兼容低版本浏览器
import 'babel-polyfill'
import Vue from 'vue'
import Element from 'element-ui/lib'
import router from './router'
import App from './App.vue'
import './theme/index.css'
import '@/config/rem.js'

Vue.use(Element)

router.afterEach(() => {
  window.scrollTo(0, 0)
})

new Vue({
  el: '#app',
  template: '<App/>',
  router,
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js